export enum InputSizeEnum {
    SM = 'SM',
    DEFAULT = 'DEFAULT',
    LG = 'LG',
}
